export default "__VITE_ASSET__DwDHiQz4__"